// Map
imageMapResize();

// TOP Swiper
(function(container) {
    if (!container) return;
    
    new Swiper(container, {
        loop: true,
        effect: 'fade',
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        speed: 2000,
    });
})(document.querySelector('.p-mv__swiper'));

function mapHover( id, mapData ) {
  let el = document.querySelector(id);
  el.addEventListener('mouseover', function() {
    document.querySelector(mapData).classList.add('is-active');
  })
  el.addEventListener('mouseleave',function(){
    document.querySelector(mapData).classList.remove('is-active');
  })
}
mapHover( '#map-hokusei', '[data-map="hokusei"]' )
mapHover( '#map-iga', '[data-map="iga"]' )
mapHover( '#map-chunansei', '[data-map="chunansei"]' )
mapHover( '#map-iseshima', '[data-map="iseshima"]' )
mapHover( '#map-higashikishu', '[data-map="higashikishu"]' )